module.exports = __webpack_public_path__ + "static/rechts-522bb44d09bc0c86d64a8dbfd399d8c8.jpg";